const LOAD_DETAIL_CANDIDATE_PATHWAY           = 'LOAD_DETAIL_CANDIDATE_PATHWAY'
const LOAD_DETAIL_CANDIDATE_PATHWAY_SUCCESS   = 'LOAD_DETAIL_CANDIDATE_PATHWAY_SUCCESS'
const LOAD_DETAIL_CANDIDATE_PATHWAY_FAILED    = 'LOAD_DETAIL_CANDIDATE_PATHWAY_FAILED'
const UNMOUNT_DETAIL_CANDIDATE_PATHWAY        = 'UNMOUNT_DETAIL_CANDIDATE_PATHWAY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const candidatePathwayReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CANDIDATE_PATHWAY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CANDIDATE_PATHWAY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CANDIDATE_PATHWAY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CANDIDATE_PATHWAY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default candidatePathwayReducer;